var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPptIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.6 10.3H6.6V13.5H8.7C9.3 13.5 9.6 13.3 9.9 13C10.2 12.7 10.3 12.4 10.3 11.9C10.3 11.4 10.2 11.1 9.9 10.8C9.6 10.5 9.2 10.3 8.6 10.3ZM10 0H2C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2V18C0 18.5304 0.210714 19.0391 0.585786 19.4142C0.960859 19.7893 1.46957 20 2 20H14C14.5304 20 15.0391 19.7893 15.4142 19.4142C15.7893 19.0391 16 18.5304 16 18V6L10 0ZM11.2 14C10.6 14.5 10.1 14.7 8.8 14.7H6.6V18H5V9H8.8C10.1 9 10.7 9.3 11.2 9.8C11.8 10.4 12 11 12 11.9C12 12.8 11.8 13.5 11.2 14ZM9 7V1.5L14.5 7H9Z",
    fill: "#343435"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPptIcon);
export default __webpack_public_path__ + "static/media/PptIcon.87170d6d5d7dde3870ac4edfacfc1ab9.svg";
export { ForwardRef as ReactComponent };